module.exports = __webpack_public_path__ + "public/img/btn.9af1feac.png";